import { NgModule } from "@angular/core";
import { RouterModule, Routes, mapToCanActivateChild } from "@angular/router";
import { ShowroomComponent } from "./common/components/showroom/showroom.component";
import { AuthenticationGuard } from "./common/guards/authentication.guard";
import { BreadcrumbNavigationGuard } from "./common/guards/breadcrumb-navigation.guard";
import { VolatileStateGuard } from "./common/guards/volatile-state.guard";
import { RaskRoller } from "./common/models/constants";
import { ExampleUsageComponent } from "./features/rask-components-example/example-usage.component";
import { Viol3PreviewComponent } from "./features/shared/components/viol3/viol3-preview/viol3-preview.component";
import { AboutComponent } from "./pages/about/about.component";
import { BadGatewayComponent } from "./pages/bad-gateway/bad-gateway.component";
import { FeatureInactivatedComponent } from "./pages/feature-inactivated/feature-inactivated.component";
import { FunktionerComponent } from "./pages/funktioner/funktioner.component";
import { InvalidUrlComponent } from "./pages/invalid-url/invalid-url.component";
import { LoginComponent } from "./pages/login/login/login.component";
import { MaintenanceComponent } from "./pages/maintenance/maintenance.component";
import { PermissionDeniedComponent } from "./pages/permission-denied/permission-denied.component";
import { PermissiontoraskDeniedComponent } from "./pages/permissiontorask-denied/permissiontorask-denied.component";
import { StartComponent } from "./pages/start/start.component";
import { administrationRoutes } from "./routes/administration-routes";
import { dokumentRoutes } from "./routes/dokument-routes";
import { forsaljningRoutes } from "./routes/forsaljning-routes";
import { leveransRoutes } from "./routes/leverans-routes";
import { leveransplanRoutes } from "./routes/leveransplan-routes";
import { produktionRoutes } from "./routes/produktion-routes";
import { transportRoutes } from "./routes/transport-routes";
import { virkeskopRoutes } from "./routes/virkeskop-routes";

const routes: Routes = [
    {
        path: "",
        canActivateChild: mapToCanActivateChild([
            AuthenticationGuard,
            VolatileStateGuard,
            BreadcrumbNavigationGuard
        ]),
        children: [
            {
                path: "",
                component: StartComponent,
                title: "Start"
            },
            {
                path: "funktioner",
                component: FunktionerComponent,
                title: "Funktioner"
            },
            {
                path: "about",
                component: AboutComponent,
                title: "Om RASK"
            },
            {
                path: "viol3/preview/:id",
                component: Viol3PreviewComponent,
                title: "Granska viol3 data",
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Titta]
                }
            },
            {
                path: "maintenance",
                component: MaintenanceComponent,
                title: "Underhåll",
                runGuardsAndResolvers: "paramsChange",
                data: {
                    publicAccess: true,
                    redirectToStartIfAuthenticated: true
                }
            },
            ...virkeskopRoutes,
            ...forsaljningRoutes,
            ...leveransplanRoutes,
            ...leveransRoutes,
            ...administrationRoutes,
            ...produktionRoutes,
            ...transportRoutes,
            ...dokumentRoutes
        ]
    },

    {
        path: "login",
        component: LoginComponent,
        title: "Logga in"
    },
    {
        path: "featureinactivated",
        component: FeatureInactivatedComponent,
        title: "Sida avaktiverad"
    },

    {
        path: "permissiondenied",
        component: PermissionDeniedComponent,
        title: "Behörighet saknas"
    },
    {
        path: "permissiontoraskdenied",
        component: PermissiontoraskDeniedComponent,
        title: "Behörighet till Rask saknas"
    },
    {
        path: "badgateway",
        component: BadGatewayComponent,
        title: "Tillfällig driftstörning"
    },
    {
        path: "components",
        canActivateChild: mapToCanActivateChild([AuthenticationGuard]),
        children: [
            {
                path: "",
                component: ShowroomComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Titta]
                }
            },
            {
                path: "example",
                component: ExampleUsageComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Titta]
                }
            }
        ]
    },
    {
        path: "**",
        pathMatch: "full",
        component: InvalidUrlComponent,
        title: "Felaktig länk"
    }
];

@NgModule({
    declarations: [],
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
